import { Alert, Typography } from '@mui/material'
import { selectPortal } from 'features/portal/portalSlice'
import i18n from 'lang/idiomas'
import { useSelector } from 'react-redux'

const PasswordRequirements = () => {
  const portal = useSelector(selectPortal)
  return (
    <Alert variant="outlined" severity="info">
      <Typography variant="h6" sx={{ mb: 3 }}>
        {i18n.t('passmust', {
          defaultValue: 'La contraseña debe',
        })}
        :
      </Typography>
      <ul style={{ listStyle: 'inside' }}>
        <li style={{ listStyle: 'inside' }}>
          {i18n.t('tenalme1', {
            defaultValue: 'Tener al menos',
          })}{' '}
          {portal?.portal?.longitud_password || 8}{' '}
          {i18n.t('tenalme2', {
            defaultValue: 'caracteres',
          })}
        </li>
        {portal?.portal?.obligar_mayusculas === 'S' ? (
          <li>
            {i18n.t('inmenmay', {
              defaultValue: 'Incluir al menos una mayúscula.',
            })}
          </li>
        ) : (
          <></>
        )}
        {portal?.portal?.obligar_numero === 'S' ? (
          <li>
            {i18n.t('incmnnum', {
              defaultValue: 'Incluir al menos un número.',
            })}
          </li>
        ) : (
          <></>
        )}
        {portal?.portal?.obligar_simbolo === 'S' ? (
          <li>
            {i18n.t('uncaresp', {
              defaultValue:
                'Incluir al menos un caracter especial: @ $ ! % * ? & " · / ( ) = ¿ + . : , ; # - _ < >',
            })}
          </li>
        ) : (
          <></>
        )}
      </ul>
    </Alert>
  )
}

export default PasswordRequirements
